import {Button} from '@freckle/educator-materials/ts/components/button'
import {Modal, Header, Body, Footer} from '@freckle/educator-materials/ts/components/modal'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'

type Props = {
  show: boolean
  removeTeacher: () => void
  onModalHide: () => void
  teacherName: string
  schoolName: string
}

export function RemoveTeacherModal(props: Props) {
  const {show, onModalHide, removeTeacher, teacherName, schoolName} = props
  const {t} = useSafeTranslation()

  return (
    <Modal show={show} onHide={onModalHide} width="medium-small" customStyle={{height: '22vh'}}>
      <Header onClickClose={onModalHide}>{t('MANAGE_TEACHERS_REMOVE_TEACHER_MODAL_TITLE')}</Header>
      <Body>
        <div className="row">
          <div className="col-12">
            <SafeTrans
              i18nKey="MANAGE_TEACHERS_REMOVE_TEACHER_MODAL_BODY"
              values={{
                school: schoolName,
                teacher: teacherName
              }}
            />
          </div>
        </div>
      </Body>
      <Footer>
        <Button onClick={onModalHide} style="secondary">
          {t('MANAGE_TEACHERS_REMOVE_TEACHER_MODAL_CANCEL')}
        </Button>
        <Button onClick={removeTeacher} style="danger">
          {t('MANAGE_TEACHERS_REMOVE_TEACHER_MODAL_OK')}
        </Button>
      </Footer>
    </Modal>
  )
}
